<template>
    <form method="POST" action="/bestellung">
        <csrf />
        <put-method />

        <section class="order">
            <div class="container">
                <div class="order__heading">
                    {{ trans('orders.form.title') }}
                </div>

                <div class="order__description">
                    {{ trans('orders.form.description') }}
                </div>

                <div class="order__form">
                    <div class="form-section">
                        <div class="form-section__heading">
                            {{ trans('orders.form.general_information') }}
                        </div>

                        <div class="form-section__body">
                            <form-input :label="trans('orders.form.firstname')" name="firstname"></form-input>
                            <form-input :label="trans('orders.form.lastname')" name="lastname"></form-input>
                            <form-input :label="trans('orders.form.email')" name="email"></form-input>
                            <form-input :label="trans('orders.form.subscription_number')" name="subscription_number" :help="trans('orders.form.subscription_number_note')"></form-input>
                        </div>
                    </div>

                    <div class="form-section">
                        <div class="form-section__heading">
                            {{ trans('orders.form.billing_information') }}
                        </div>


                        <div class="form-section__body">
                            <form-input :label="trans('orders.form.company')" name="company"></form-input>
                            <form-input :label="trans('orders.form.phone')" name="phone"></form-input>
                            <form-input v-if="!is_po_box" :label="trans('orders.form.street')" name="address"></form-input>
                            <form-input v-else :label="trans('orders.form.postbox')" name="address"></form-input>
                            <form-input-group>
                                <form-input slot="small" :label="trans('orders.form.zip')" name="zip"></form-input>
                                <form-input slot="big" :label="trans('orders.form.city')" name="city"></form-input>
                            </form-input-group>
                        </div>
                        <checkbox class="h:margin-bottom-2" v-model="is_po_box" name="is_po_box">{{ trans('orders.form.use_postbox') }}</checkbox>
                    </div>

                    <div class="form-section">
                        <div class="form-section__heading">
                            {{ trans('orders.form.order_information') }}
                        </div>

                        <div class="form-section__body">
                            <form-input type="number" :label="trans('orders.form.license_amount')" name="license_count"></form-input>
                        </div>

                        <alert-box>{{ trans('orders.form.license_note') }}</alert-box>

                        <selected-products v-model="products"></selected-products>
                    </div>
                </div>

                <page-control :label="trans('page-control.summary')" button margin-bottom></page-control>

                <page-control :label="trans('page-control.back_to_products')" link href="/produkte" margin-bottom></page-control>
            </div>
        </section>
    </form>
</template>

<script>
export default {
    props: {
        selectedProducts: Array,
    },

    data() {
        return {
            is_po_box: false,
            products: this.selectedProducts,
        };
    }
}
</script>
